/*
 * Announcement bar — mobile-only marquee fallback.
 *
 * The combined "Free Delivery on All Gift Sets · 10% Off Your First
 * Order" announcement always renders as a single, static, centred line
 * (see soluscent-styles.css) unless this script finds it doesn't fit on
 * one line below this theme's own 750px mobile breakpoint. Only then
 * does it duplicate the text and turn on the CSS scroll animation, so
 * the bar never animates at desktop/tablet widths or on a mobile width
 * where the sentence already fits.
 *
 * Re-evaluates on load, resize/orientation change, and
 * shopify:section:load so Theme Editor edits to the announcement text
 * don't leave a stale measurement in place.
 */
(function () {
  var MESSAGE_SELECTOR = '[data-soluscent-announcement-message]';
  var DESKTOP_BREAKPOINT = 750; // matches this theme's own mobile breakpoint in soluscent-styles.css
  var GAP_PX = 48; // must match the padding-right on [data-soluscent-announcement-copy] in CSS
  var PIXELS_PER_SECOND = 45;
  var MIN_DURATION_S = 6;
  var FIT_TOLERANCE_PX = 1;

  function teardown(message) {
    var track = message.querySelector('[data-soluscent-announcement-track]');
    if (track) {
      var clones = track.querySelectorAll('[data-soluscent-announcement-clone]');
      for (var i = 0; i < clones.length; i++) {
        clones[i].parentNode.removeChild(clones[i]);
      }
    }
    message.classList.remove('is-soluscent-marqueeing');
    message.style.removeProperty('--soluscent-marquee-distance');
    message.style.removeProperty('--soluscent-marquee-duration');
  }

  function evaluate(message) {
    var track = message.querySelector('[data-soluscent-announcement-track]');
    var original = message.querySelector('[data-soluscent-announcement-copy]');
    var container = message.closest('.announcement-bar');
    if (!track || !original || !container) return;

    teardown(message);

    if (window.innerWidth >= DESKTOP_BREAKPOINT) return;

    var fits = original.scrollWidth <= container.clientWidth - FIT_TOLERANCE_PX;
    if (fits) return;

    var clone = original.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-soluscent-announcement-clone', '');
    clone.removeAttribute('data-soluscent-announcement-copy');
    track.appendChild(clone);

    var distance = original.scrollWidth + GAP_PX;
    var duration = Math.max(distance / PIXELS_PER_SECOND, MIN_DURATION_S);

    message.style.setProperty('--soluscent-marquee-distance', '-' + distance + 'px');
    message.style.setProperty('--soluscent-marquee-duration', duration + 's');
    message.classList.add('is-soluscent-marqueeing');
  }

  function evaluateAll() {
    var messages = document.querySelectorAll(MESSAGE_SELECTOR);
    for (var i = 0; i < messages.length; i++) evaluate(messages[i]);
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(evaluateAll, 150);
  }

  if (document.readyState !== 'loading') evaluateAll();
  else document.addEventListener('DOMContentLoaded', evaluateAll);

  window.addEventListener('load', evaluateAll);
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(evaluateAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector(MESSAGE_SELECTOR)) evaluateAll();
  });
})();
